import React, { useEffect, useRef } from 'react'

const IndeterminateSelectBox = React.forwardRef(({ indeterminate, ...rest }, ref) => {
  const defaultRef = useRef()
  const resolvedRef = ref || defaultRef

  useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate
  }, [resolvedRef, indeterminate])

  return (
    <div className="indeterminate-select-box">
      <input ref={resolvedRef} {...rest} />
      <span></span>
    </div>
  )
})

IndeterminateSelectBox.displayName = 'IndeterminateSelectBox'

export default IndeterminateSelectBox
